'use client';
import { useTranslations } from 'next-intl';
import type { FC } from 'react';
import { RedError } from '@/app/components/icons/RedError';

interface PageErrorMsgProps {
  message?: string;
}
export const PageErrorMsg: FC<PageErrorMsgProps> = ({ message }) => {
  return (
    <div className="flex h-full flex-col items-center justify-center">
      <RedError className="text-4xl" />
      <div className="mt-8 max-w-[550px] text-center font-bold text-system-text04 text-xl leading-8 lg:max-w-[500px] lg:text-lg">
        {message}
      </div>
    </div>
  );
};

export const PageLoadError = () => {
  const t = useTranslations();
  return (
    <div className="h-screen">
      <PageErrorMsg message={t('loadError')} />
    </div>
  );
};
